import { isLinkMode } from '@/utils/api';
import { useStore } from '@/utils/vue-api';
import { getCurrentInstance } from 'vue';
import { useCommonData } from '@/hooks';

export const useStoreCore = () => {
	const store = useStore();
	const vm = getCurrentInstance();

	const { isSlideTmpl, isFlowXTmpl, isFlowTmpl } = useCommonData();

	const getUIControls = () => {
		/*
			侧边栏：首页 / 有菜单UI / 组件
			瀑布流：首页 / 无菜单UI / 组件

			home			任意的首页入口
			menuBar			菜单切换栏
			moduleBar		组件切换栏
		*/

		const formLinkMode = isLinkMode();
		const isMobile = store.state.accessMode === 'mobile';
		const inSlideTmpl = isSlideTmpl.value;
		const inFlowTmpl = isFlowXTmpl.value || isFlowTmpl.value;

		const source = vm.proxy.$route.meta?.source;
		const visTmplMenu = source === 'menu';
		const visTmplIndex = source === 'home';

		const { menuId, moduleId } = vm.proxy.$route.params;
		const { muid, mid } = vm.proxy.$route.query;

		const { pageMenuVOS = [] } = store.getters.getCommonData;
		const findHomeMenu = pageMenuVOS.find(item => item.homePage === 1);
		const visHomeMenu = menuId && findHomeMenu?.id === menuId;

		// 历史链接中的二级页面 取消首页快捷入口 隐藏菜单栏
		// PS：https://irm-enterprise-pc.comein.cn/announcement?storeId=20138
		const visInModuleRoute = source === 'module';
		if (visInModuleRoute) {
			if (isMobile) return [];
			return ['menuBar'];
		}

		if (inSlideTmpl) {
			if (formLinkMode) {
				if (muid !== undefined && mid !== undefined) return ['home'];
				if (muid !== undefined) return ['home', 'moduleBar'];
				if (visTmplIndex) return ['home', 'menuBar', 'moduleBar'];
				return [];
			}
			return ['home', 'menuBar', 'moduleBar'];
		}
		if (inFlowTmpl) {
			if (formLinkMode) {
				if (visTmplMenu && moduleId !== undefined) return ['home'];
				if (visTmplMenu) {
					if (isMobile) return ['home', 'moduleBar'];
					return ['home'];
				}
				if (visTmplIndex) return ['home'];
			}
			if (isMobile) {
				if (visHomeMenu) return ['home', 'menuBar'];
				return ['home', 'menuBar', 'moduleBar'];
			}
			return ['home', 'menuBar'];
		}
		return [];
	};
	const shouldShowUI = control => {
		const controls = getUIControls();
		return controls.includes(control);
	};

	return {
		getUIControls,
		shouldShowUI
	};
};
